// src/hooks/usePurchaseForm.js
//
// Shared purchase-form state/validation/navigation, extracted from
// BuyPhysicalBook.js and BuyAudiobookEbook.js so each format on BuyBook.js
// doesn't re-implement the same qty/name/phone/email handling. The
// navigate() payload shape is unchanged from the original pages, since
// Buy_checkout_no_influencer.js reads `state.type/qty/amount/...` directly.
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export function usePurchaseForm({ type, price, needsShipping = false }) {
  const navigate = useNavigate();

  const [fields, setFields] = useState({
    qty: '1',
    name: '',
    phone: '',
    email: '',
    description: '',
    street: '',
    city: '',
    state_province: '',
    postal_ZIP_code: '',
    country: '',
  });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setError('');
    setFields((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const qty = Number(fields.qty) || 0;
  const subtotal = qty * price;

  const submit = (e) => {
    e.preventDefault();
    setError('');

    const hasContactInfo = fields.name.trim() && fields.phone.trim() && fields.email.trim();
    const hasShipping = !needsShipping || (
      fields.street.trim() && fields.city.trim() &&
      fields.state_province.trim() && fields.postal_ZIP_code.trim() && fields.country
    );

    if (!hasContactInfo) {
      setError('Please fill in your name, phone, and email to continue.');
      return;
    }
    if (!hasShipping) {
      setError('Please add your shipping address to continue.');
      return;
    }
    if (qty < 1) {
      setError('Quantity must be at least 1.');
      return;
    }

    setSubmitting(true);

    const payload = {
      type,
      qty: fields.qty,
      amount: subtotal,
      name: fields.name,
      phone: fields.phone,
      email: fields.email,
      description: fields.description,
      country: fields.country,
    };

    if (needsShipping) {
      payload.street = fields.street;
      payload.city = fields.city;
      payload.state_province = fields.state_province;
      payload.postal_ZIP_code = fields.postal_ZIP_code;
    }

    // Checkout (PayPal, totals, shipping calc) happens on the next page;
    // this hook's job ends at handing off a valid, well-formed order.
    navigate('/Buy_checkout_no_influencer', { state: payload });
  };

  return { fields, handleChange, error, submit, subtotal, qty, submitting };
}
